import { Account } from "./account";
import { Horse } from "./horse";
import { HorseNominationPayment } from "./horseNominationPayment";

export class HorseNomination {
    id: number;
    nominationId: number;
    
    account: Account;
    accountId: number;

    horse: Horse;
    horseId: number;
    
    time: string;
    status: string;
    confirmationCode: string;
    payConfirmationCode: string;

    horseName: string;
    sireName: string;
    ownerName: string;
    breederName: string;

    payments: HorseNominationPayment[];
    updated: string;
}


// WEBPACK FOOTER //
// ./src/model/horseNomination.ts